import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import CiScrollEvent from "./CiScrollEvent";
import CiSignature from "../../../components/CiSignature";
import CiColorSystem from "../../../components/CiColorSystem";
import CiDownload from "../../../components/CiDownload";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const Ci = () => {
  const { t } = useTranslation();
  const title = `The Smart Green ESG\nPlatform Leader`;
  const formatCi = {
    title: t("aboutUs.ci.ci.title"),
    ment: t("aboutUs.ci.ci.ment"),
    img_path_01: "/imgs/ci_main_1440.png",
    img_path_02: "/imgs/ci_black_470.png",
    img_path_03: "/imgs/ci_white_470.png",
    img_path_04: "/imgs/ci_main_470.png",
    img_path_05: "/imgs/ci_interval_type1.png",
    img_path_06: "/imgs/ci_interval_type2.png",
  };
  const formatBi = {
    title: t("aboutUs.ci.bi.title"),
    ment: t("aboutUs.ci.bi.ment"),
    img_path_01: "/imgs/bi_main_1440.png",
    img_path_02: "/imgs/bi_black_470.png",
    img_path_03: "/imgs/bi_white_470.png",
    img_path_04: "/imgs/bi_main_470.png",
    img_path_05: "/imgs/bi_interval_type1.png",
    img_path_06: "/imgs/bi_interval_type2.png",
  };
  return (
    <>
      <Seo title={`${t("aboutUs.ci.seo.title")}`} description={`${t("aboutUs.ci.seo.des")}`} path="about/ci" />
      <TitleFormat text={title} />
      <CiScrollEvent />

      <CiSignature
        title={formatCi.title}
        ment={formatCi.ment}
        img_path_01={formatCi.img_path_01}
        img_path_02={formatCi.img_path_02}
        img_path_03={formatCi.img_path_03}
        img_path_04={formatCi.img_path_04}
        img_path_05={formatCi.img_path_05}
        img_path_06={formatCi.img_path_06}
      />
      <CiSignature
        title={formatBi.title}
        ment={formatBi.ment}
        img_path_01={formatBi.img_path_01}
        img_path_02={formatBi.img_path_02}
        img_path_03={formatBi.img_path_03}
        img_path_04={formatBi.img_path_04}
        img_path_05={formatBi.img_path_05}
        img_path_06={formatBi.img_path_06}
      />
      <CiColorSystem />
      <CiDownload />
    </>
  );
};

export default Ci;
